import React from "react";
import "../../assets/styles/styles.less";
import "./styles.less";
import texts from "../../assets/strings/select";
import CharityCard from "./CharityCard";
import Slider from "react-slick";
import descriptions from "../../assets/strings/charities";

const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1
};
const SelectCharityMobile = props => (
  <div className="selectCharity mobile">
    <div style={{ padding: "8px" }}>
      <h1>{texts.h1}</h1>
      <h3 className="areaTitle">{texts.h3}</h3>
      <p className="note">{texts.note}</p>
    </div>
    <div className="charities-list">
      <Slider {...settings}>
        {props.reducer.featuredCharities.map((charity, idx) => (
          <CharityCard
            key={`charity-${idx}`}
            charity={charity}
            description={descriptions[charity.ein]}
            onClick={props.selectCharity}
            showActions={true}
            isResponse={props.details.isResponse}
          />
        ))}
      </Slider>
    </div>
  </div>
);

export default SelectCharityMobile;



// WEBPACK FOOTER //
// ./components/SelectCharity/SelectCharityMobile.js